import { app, Component } from 'apprun';
import { __, lang } from './Txlat';
import { getPropertyLink, paginateAssets, PageSize, checkNumber } from './utility';
import { sortProperties, getPropertyDetailStatusPrice } from './model/property';
import PageControl from './pageControl';

export default class PropertyListing extends Component {
  view = (state) => {
    return (<PropertyListingTemplate state={state} />);
  };

  update = {
    'sort-order-changed': (state, e) => {
      const sortOrderId = e.currentTarget.id;

      let sortBy;
      switch (sortOrderId) {
        case 'bs-select-1-1': sortBy = 'a_price'; break;
        case 'bs-select-1-2': sortBy = 'd_price'; break;
        case 'bs-select-1-3': sortBy = 'a_date'; break;
        case 'bs-select-1-4': sortBy = 'd_date'; break;
        default: sortBy = ''; break;
      }

      state.properties = sortProperties(state.properties, sortBy);

      state.page = 1;
      state.pageProperties = paginateAssets(state.properties, state.page);

      state.propSortOrder = e.target.innerText;
      return state;
    },

    '/setComponentState': async (state, { properties, agent = null }) => {
      state.properties = properties;
      state.sortby = '';

      state.properties = sortProperties(state.properties, state.sortby);
      state.pageProperties = paginateAssets(state.properties, 1);
      state.page = 1;

      state.agent = agent;

      state.propSortOrder = 'Default Order';
      return state;
    },

    'gotoPage': (state, targetPageNumber) => {
      state.page = targetPageNumber;
      state.pageProperties = paginateAssets(state.properties, targetPageNumber);
      return state;
    },
  };

}

function PropertyListingTemplate({ state }) {

  const { properties, pageProperties, page, propSortOrder } = state;
  if (!properties) { return; }
  return (
    <div>
      <style>{'.btn-detail {color: #fff;background-color: #ea002a;border-color: #ea002a;}.btn-detail:focus, .btn-detail:focus:active {color: #fff;background-color: #333333;border-color: #333333;}.btn-detail:hover {color: #fff;background-color: #333333;border-color: #333333;}.btn-detail:active, .btn-detail:not(:disabled):not(:disabled):active {color: #fff;background-color: #ea002a;border-color: #ea002a;}'}</style>
      {properties && properties.length ? <><div class="listing-tools-wrap">
        <div class="d-flex align-items-center">
          <div class="page-title flex-grow-1">
            <PageControl page={page} total={properties.length} size={PageSize} type='property' />
          </div>
          <div class="sort-by">
            <div class="d-flex align-items-center">
              <div class="sort-by-title">
                {__('Sort by')}:
              </div>
              <div id="divDropDown" class="dropdown bootstrap-select form-control">
                <button type="button" tabindex="-1" class="btn dropdown-toggle btn-light bs-placeholder" data-toggle="dropdown" role="combobox" aria-owns="bs-select-1" aria-haspopup="listbox" aria-expanded="false" data-id="sort_properties" title="Default Order">
                  <div class="filter-option">
                    <div class="filter-option-inner">
                      <div class="filter-option-inner-inner">{__(propSortOrder)}</div>
                    </div>
                  </div>
                </button>

                <ul class="dropdown-menu" role="presentation" style="margin-top: 0px; margin-bottom: 0px; text-transform:none">
                  <li><a $onclick='sort-order-changed' role="option" class="dropdown-item" id="bs-select-1-0" tabindex="0" aria-setsize="6" aria-posinset="1" aria-selected="true"><span class="text">{__('Default Order')}</span></a></li>
                  <li><a $onclick='sort-order-changed' role="option" class="dropdown-item" id="bs-select-1-1" tabindex="0"><span class="text">{__('Price - Low to High')}</span></a></li>
                  <li><a $onclick='sort-order-changed' role="option" class="dropdown-item" id="bs-select-1-2" tabindex="0" aria-setsize="6" aria-posinset="3"><span class="text">{__('Price - High to Low')}</span></a></li>

                  <li><a $onclick='sort-order-changed' role="option" class="dropdown-item" id="bs-select-1-3" tabindex="0"><span class="text">{__('Date - Old to New')}</span></a></li>
                  <li><a $onclick='sort-order-changed' role="option" class="dropdown-item" id="bs-select-1-4" tabindex="0"><span class="text">{__('Date - New to Old')}</span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>{pageProperties.map(p => <div>{PropertyTemplate(p)}</div>)}
      </> : ''}
    </div>
  );
}

function PropertyTemplate(prop) {
  const statusPrice = getPropertyDetailStatusPrice(prop);
  //console.log(prop);
  return (
    <section class="listing-wrap listing-v1">
      <div class="listing-view list-view card-deck">
        <div class="item-listing-wrap hz-item-gallery-js card" data-images="[&quot;\/wp-content\/uploads\/2016\/03\/013-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/036-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/040-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/045-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/047-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/013-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/008-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/012-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/030-592x444.jpg&quot;,&quot;\/wp-content\/uploads\/2016\/03\/035-592x444.jpg&quot;]">
          <div class="item-wrap item-wrap-v1 item-wrap-no-frame h-100">
            <div class="d-flex align-items-center h-100">
              <div class="item-header">
                <div class="listing-image-wrap">
                  <div class="listing-thumb">
                    <a target={'property' + prop.id} href={getPropertyLink(prop, lang.get())} class="listing-featured-thumb hover-effect" >
                      <img width="280" height="210" src={prop.property_photo} class="img-fluid wp-post-image" alt="" loading="lazy" style="width:280; height: 210px !important; object-fit: cover;object-position:0 0; max-width: 100%; cursor: pointer; " />
                    </a>
                  </div>
                </div>
              </div>
              <div class="item-body flex-grow-1">
                <div class="labels-wrap labels-right mb-0">
                  <label class="label-status" style="color:red">
                    {statusPrice.status}
                  </label>
                </div>

                <ul class="item-amenities item-amenities-with-icons">
                  <li>
                    <h2 class="item-title">
                      <a target={'property' + prop.id} href={getPropertyLink(prop, lang.get())}><b>{prop.address}</b></a>
                    </h2>
                  </li>
                </ul>

                <ul class="item-price-wrap hide-on-list">
                  <li class="item-price">{statusPrice.price}</li>
                </ul>
                <address class="item-address">{`${prop.city} ${prop.province} ${prop.postal_code || ''}`}</address>
                <ul class="item-amenities item-amenities-with-icons">
                  <li class="h-area"><i class="houzez-icon icon-ruler-triangle mr-1"></i><span class="hz-figure">{checkNumber(prop.total_area)}</span> <span class="area_postfix">{' ' + __('Sq Ft')}</span></li>
                  <li class="h-type"><span>{lang.get() === 'en' ? (prop.property_type[0] ? prop.property_type[0].toUpperCase() : '') : (prop.property_type[1] ? prop.property_type[1].toUpperCase() : '')}</span></li>
                </ul>
                <ul class="item-amenities item-amenities-with-icons"><li><span>MLS® {prop.mls_id}</span></li></ul>

                <ul class="item-amenities item-amenities-with-icons">
                  <div class="d-flex flex-row">
                    <div class="p-2 flex-grow-1">
                      <i class="houzez-icon icon-single-neutral mr-1"></i>20{prop.last_updated.slice(0, 8)}
                    </div>
                    <div class="p-2 ">
                      <a class="btn btn-search btn-detail btn-item " target={`property${prop.id}`} href={getPropertyLink(prop, lang.get())}>{__('Details')}</a>
                    </div>
                  </div>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
}
